import React from "react";
import Row from "../components/Row";
import Column from "../components/Column";

const DelConditions = (props) => {
  const delConditions = props.conditions.map((rules) => {
    return (
      <Column extraClasses="p-top__large p-left__medium p-bottom__large column size__one-of-two">
        <h4 className="green-text m-bottom__none creme-background p-around__medium">
          {rules.title}
        </h4>

        {rules.conditions.map((condition) => {
          return (
            <p
              className="rules-item line-height__large"
              dangerouslySetInnerHTML={{ __html: condition }}
            ></p>
          );
        })}
      </Column>
    ); //one block
  });

  return (
    <div className="del-rules content-width center size__one-of-one row">
      {delConditions}
    </div>
  );
};
export default DelConditions;
